import React from "react";

export default function TableSkeleton({ columns, rows = 8 }) {
  return (
    <div className="nfl-skeleton" role="status" aria-busy="true" aria-label="Loading">
      <table className="nfl-skeleton-table">
        <thead>
          <tr>
            {columns.map((column, i) => (
              <th key={column} className={"nfl-display" + (i === 0 ? " is-left" : "")}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, row) => (
            <tr key={row}>
              {columns.map((column, i) => (
                <td key={column} className={i === 0 ? "is-left" : undefined}>
                  <span
                    className="nfl-shimmer"
                    style={{
                      width: i === 0 ? 110 + ((row * 37) % 60) : 24 + ((row + i) % 3) * 8,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
